module.exports = __webpack_public_path__ + "img/dianhua.a7602c83.png";